import React from 'react';
import { Spinner } from 'react-bootstrap';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(255,255,255,0.8)',
  zIndex: 2000,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

const Loader = ({ message = '' }) => (
  <div style={overlayStyle} >
    <Spinner animation="border" role="status" variant="primary" style={{ width: '3rem', height: '3rem' }}>
      <span className="visually-hidden">{message}</span>
    </Spinner>
    <div className="mt-3 text-primary fw-semibold">{message}</div>
  </div>
);

export default Loader;
